"use client";
import { Translate } from "@/components/Translate";
import BlokWrap from "@/components/bloks/BlokWrap";
import { trackContentClick } from "@/lib/analytics/trackContentClick";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokRetailer } from "@/storyblok";
import type { AssetStoryblokCompat } from "@/types/storyblok-compat";
import { type BlokProps, getMedia } from "@frend-digital/storyblok";
import { useMediaQuery } from "@frend-digital/ui/hooks";
import Image from "next/image";
import type { StoryblokMultilink } from "storyblok";
import styles from "./RetailerBlok.module.css";

export const RetailerBlok = ({ blok, preview }: BlokProps<BlokRetailer>) => {
	const isMobile = useMediaQuery("(max-width: 1024px)");
	const websiteLink = sbLink(blok.websiteUrl as StoryblokMultilink);
	return (
		<BlokWrap editable={blok} as="div" className={styles.root}>
			<div className={styles.cardInner}>
				<div className={styles.cardContent}>
					<h3 className={styles.cardTitle}>{blok.name}</h3>
					<p className={styles.cardAddress}>{blok.address as string}</p>
					<p className={styles.cardAddress}>{blok.email}</p>
					<p className={styles.cardAddress}>{blok.phone}</p>
					{!!websiteLink?.href && (
						<a
							href={websiteLink.href}
							target="_blank"
							rel="noopener noreferrer"
							className={styles.cardLink}
							onClick={() =>
								trackContentClick({
									contentType: blok.component,
									itemId: blok._uid,
									href: websiteLink.href,
									label: "Visit website",
								})
							}
						>
							<Translate>Visit website</Translate>
						</a>
					)}
				</div>
				{!isMobile &&
					blok.image &&
					(() => {
						const media = getMedia(blok.image as AssetStoryblokCompat);
						if (!media) return null;

						return (
							<div className={styles.cardImageWrapper}>
								<div className={styles.image}>
									<Image src={media.url} alt={blok.name!} fill />
								</div>
							</div>
						);
					})()}
			</div>
		</BlokWrap>
	);
};
